import { Outlet } from 'react-router-dom';
import { useAuthStore } from '@/features/auth';
import { RefreshCw, LogOut } from 'lucide-react';

/**
 * Minimal layout for iframe embedding in speakIQ portal.
 * Includes small toolbar with logout and refresh for auth management.
 */
export function EmbedLayout() {
  const { user, logout } = useAuthStore();

  const handleRefresh = () => {
    window.location.reload();
  };

  const handleLogout = async () => {
    await logout();
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Minimal toolbar */}
      <div className="bg-slate-50 border-b border-slate-200 px-4 py-2 flex items-center justify-between">
        <span className="text-sm text-slate-600">
          {user?.email || 'Carrier Services'}
        </span>
        <div className="flex items-center gap-2">
          <button
            onClick={handleRefresh}
            className="p-2 text-slate-500 hover:text-slate-700 hover:bg-slate-100 rounded-lg transition-colors"
            title="Refresh"
          >
            <RefreshCw className="h-4 w-4" />
          </button>
          <button
            onClick={handleLogout}
            className="p-2 text-slate-500 hover:text-red-600 hover:bg-red-50 rounded-lg transition-colors"
            title="Log Out"
          >
            <LogOut className="h-4 w-4" />
          </button>
        </div>
      </div>

      {/* Content */}
      <main className="p-2">
        <Outlet />
      </main>
    </div>
  );
}
